// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
//import store from './store'
import '@/styles/reset.css'
import '@/styles/font.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.config.productionTip = false
/* 引入elementUI */
//import '../src/styles/theme.css'
//import '../src/styles/config.json'
//import '../src/styles/theme/xuanxing.scss'
import 'element-ui/lib/theme-chalk/index.css'
import '../theme/index.css'
import ElementUI from 'element-ui'
//import 'element-ui/lib/theme-chalk/index.css'
import i18n from './i18n/i18n';
//Vue.use(store)
Vue.use(VueAxios, axios)
Vue.use(ElementUI)
/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  i18n,
  //store,
  template: '<App/>',
  components: { App }
})




// WEBPACK FOOTER //
// ./src/main.js